import { Capacitor } from '@capacitor/core'
import { LocalNotifications } from '@capacitor/local-notifications'
import { showBanner } from '@/services/ui/banner'

// Notifications are created on the phone itself: no push service, no server.

const ASKED_KEY = 'notifications.asked'

const isNative = () => Capacitor.isNativePlatform()

const allowed = async () => {
  if (!isNative()) return false
  const { display } = await LocalNotifications.checkPermissions().catch(() => ({ display: 'denied' }))
  return display === 'granted'
}

// Asked once per install, after login: the system shows its own dialog. Remembered only
// once the request went through, so a failed attempt is retried on the next start.
export async function askNotificationPermissionOnce() {
  if (!isNative()) return
  try {
    if (localStorage.getItem(ASKED_KEY)) return
    const { display } = await LocalNotifications.checkPermissions()
    if (display === 'prompt' || display === 'prompt-with-rationale') await LocalNotifications.requestPermissions()
    localStorage.setItem(ASKED_KEY, '1')
  } catch (err) {
    console.warn('[Notify] Permission request failed:', err)
  }
}

// A system notification when the user allowed them; otherwise the in-app banner, unless
// the caller shows its own banner anyway (banner: false).
export async function notify({ title, body, banner = true }) {
  if (await allowed()) {
    try {
      await LocalNotifications.schedule({
        // Shown right away: not an exact alarm, otherwise Android opens the
        // "Alarms & reminders" settings before every notification.
        notifications: [{ id: Date.now() % 2147483647, title, body, smallIcon: 'ic_notification', isExactNotification: false }],
      })
      return
    } catch (err) {
      console.warn('[Notify] Could not show notification:', err)
    }
  }
  if (banner) showBanner({ title, message: body })
}
